import {Urls} from '../constants'
import 'styles/productone.scss'

(function(){

    const authSettings = $.sc.authSettings;
    let securityGuids = [];
    let domSection = '';

    let currentState = {
        IsTimesheetEnabled: false,
        summaryParameters: {},
        displayEnrollmentSection: true,
        IsElectronic: false
    }

    async function getHiringProgramsListEndPoint() {
		const endpoint = new URL(`${window.location.protocol}//${window.location.host}/s4s/api/HiringProgram/PrincipalPrograms`);
		const response = await fetch(endpoint);
		const data = await response.json();
		return data;
	}

    async function getHiringProgramEndPoint(id) {
		const endpoint = new URL(`${window.location.protocol}//${window.location.host}/s4s/api/HiringProgram/Get/${id}`);
		const response = await fetch(endpoint);
		const data = await response.json();
		return data;
	}

    async function getPPLUserEndPoint(id) {
		const endpoint = new URL(`${window.location.protocol}//${window.location.host}/s4s/api/PPLUser/Get/${id}`);
		const response = await fetch(endpoint);
		const data = await response.json();
		return data;
	}

    // async function getBalance(principalId) {
	// 	const endpoint = new URL(`${window.location.protocol}//${window.location.host}/s4s/api/Balance/GetBalance?PrincipalId=${principalId}`);
	// 	const response = await fetch(endpoint);
	// 	const data = await response.json();
	// 	return data;
	// }

    async function getBalance(principalId) {
        const endpoint = new URL(`${window.location.protocol}//${window.location.host}/s4s/api/Balance/GetBalance?PrincipalId=${principalId}`);
        try {
            const response = await fetch(endpoint);  // Normal fetch request (allows redirects)
            // console.log("Final Response Status:", response.status); // Logs final status (200 or other)
            // Check if redirected
            if (response.redirected) {
                // console.warn("Redirect detected! Redirected to:", response.url);
     
                // Display message in the UI
                const fundsSection = document.querySelector('.funds_section');
                const messageBox = document.querySelector('.js-hero_circle');

                if (fundsSection && messageBox) {
                    messageBox.innerHTML = '<h1>Please sign in again to view your balance.</h1>';
                    fundsSection.style.display = 'none';
                }

                return null;  // Stop further processing if redirected
            }
     
            // If not redirected, continue as usual
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error fetching balance:', error);
            throw error;
        }
    }
    

    function summaryParameters(callback) {
		fetch("/s4s/api/PPLDashboard/SummaryParameters", {
            "headers": {
                "content-type": "application/json",
            },
            // "body": JSON.stringify(dataObj),
            "method": "POST",
            "mode": "cors",
            "credentials": "include"
        })
        .then(function(data){ 
            return data.json();
        })
        .then(function(data){ 
            console.log(data)

			// Error
            // if ( data.Errors.length > 0) {
            //     createModel('Unable to create payee', `<p> ${data.Errors[0].Description === null ? '' : data.Errors[0].Description} ${data.Errors[0].MessageResource === null ? '' : data.Errors[0].MessageResource} </p>`)
			// }

            callback(data);
        })
	}

    // Overlay spinner function
    function overlay() {
        $('body').prepend(
            '<div class="js-overlay" style="width: 100%; height: 100%; position: fixed; z-index: 10000000; top: 0; display: flex; justify-content: center; background-color: rgba(0, 0, 0, 0.2)">' +
                // '<svg style="width: 80px;" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="spinner" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-spinner fa-w-16 fa-spin fa-lg"><path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z" class=""></path></svg>' +
            '</div>'
        );
    };

     async function getPPLUser(id, callback) {
        const getPPLUserEndpoint = await getPPLUserEndPoint(id);
        currentState.IsElectronic = getPPLUserEndpoint.Data.IsNonElectronic;
        callback();
    }

    async function getHiringPrograms(callback) {

        const getHiringListEndpoint = await getHiringProgramsListEndPoint();
        if (getHiringListEndpoint.Data.length) {
            const hiringId = getHiringListEndpoint.Data[0].Id;
            const getHiringItemEndpoint = await getHiringProgramEndPoint(hiringId);
            currentState.IsTimesheetEnabled = getHiringItemEndpoint.Data.IsTimesheetEnabled;
        }

        callback();
    }

    // If logged in then show the spiiner before redirect, or else show the welcome page
    function vwDashboardPage(){

        //summaryParameters(function(response){
        
            const data = currentState.summaryParameters.Data;

            if ( $.sc.authSettings.isEmployer === true) {
                if ( $.sc.authSettings.securityGroups.indexOf(Urls.virtualWalletLiteSecurityGroup) <= -1 ) {
                    createWeeklyFundingTable();
                }
            }

            // Individual with enrolment, dashboard page
            if($.sc.authSettings.isIndividual === true && $.sc.authSettings.pplId !== null){

                $('#maincontent').append(domSection.individualEnrolmentHeroSection)
                $('#maincontent').append(domSection.individualEnrolmentSection)
                $('#maincontent').append(domSection.balanceSection)

                getProductTwo(function(){

                    // Hide and toggle enrolment section if it is complete (Add provier validation when done testing - && data.MyEmployees.CompletedCount > 0)
                    if(currentState.displayEnrollmentSection === false || currentState.IsElectronic === true) {


                        $('.js-hero-enrolment-icon i').removeClass();
                        $('.js-hero-enrolment-icon i').addClass('fas fa-check hero_tick-icon');

                        $('.enrolment_section').css('display', 'none');
                        $('.js-enrolment_toggle').html(`View enrolment details <i aria-hidden="true" class="enrolment_toggle-icon fas fa-chevron-down"></i>`);

                    } else {
                        $('.js-hero_circle-enrolment-status').html('In progress');

                        $('.js-hero-enrolment-icon i').removeClass();
                        $('.js-hero-enrolment-icon i').addClass('fas fa-map-marker-alt');
                    }

                });

            }

            // Individual without enrolment, dashboard page
            if($.sc.authSettings.isIndividual === true && $.sc.authSettings.pplId === null){
                
                $('#maincontent').append(domSection.balanceHeroSection)
                $('#maincontent').append(domSection.balanceSection)

                getProductTwo();

            }

            // Employee with enrolment, dashboard page
            if($.sc.authSettings.isIndividual === false && $.sc.authSettings.isEmployee === true && $.sc.authSettings.pplId !== null && $.sc.authSettings.isAuthorizedRepresentative === false){

                $('#maincontent').append(domSection.employeeEnrolmentHeroSection)
                $('#maincontent').append(domSection.employeeEnrolmentSection)
                $('#maincontent').append(domSection.quickLinksSection)

                // Hide and toggle enrolment section if it is complete
                if(currentState.displayEnrollmentSection === false) {

                    $('.js-hero_circle').html(
                        `
                        <h2 class="hero_circle-heading">Enrolment Status</h2>
                        <p class="hero_circle-heading-bold js-hero_circle-enrolment-status">Enrolled</p>
                        `
                    );

                    $('.js-hero-enrolment-icon i').removeClass();
                    $('.js-hero-enrolment-icon i').addClass('fas fa-check hero_tick-icon');

                    $('.enrolment_section').css('display', 'none');
                    $('.js-enrolment_toggle').html(`View enrolment details <i aria-hidden="true" class="enrolment_toggle-icon fas fa-chevron-down"></i>`);

                    } else {
                    $('.js-hero_circle-enrolment-status').html('In progress');

                    $('.js-hero-enrolment-icon i').removeClass();
                    $('.js-hero-enrolment-icon i').addClass('fas fa-map-marker-alt');
                }

            }           
            
            // Employee without enrolment, dashboard page
            if($.sc.authSettings.isIndividual === false && $.sc.authSettings.isEmployee === true && $.sc.authSettings.pplId === null && $.sc.authSettings.isAuthorizedRepresentative === false){

                $('#maincontent').append(domSection.blankHeroSection)
                $('#maincontent').append(domSection.quickLinksSection)

            }
            
            // isAuthorizedRepresentative enrollment dashboard
            if($.sc.authSettings.isAuthorizedRepresentative === true && $.sc.authSettings.pplId !== null && $.sc.authSettings.hasPba === false){

                $('#maincontent').append(domSection.employeeEnrolmentHeroSection)
                $('#maincontent').append(domSection.authRepEnrolmentSection)

                getProductTwo(function(){
                    // Hide and toggle enrolment section if it is complete
                    if(currentState.displayEnrollmentSection === false) {
    
                        $('.js-hero_circle').html(
                            `
                            <h2 class="hero_circle-heading">Enrolment Status</h2>
                            <p class="hero_circle-heading-bold js-hero_circle-enrolment-status">Enrolled</p>
                            `
                        );
    
                        $('.js-hero-enrolment-icon i').removeClass();
                        $('.js-hero-enrolment-icon i').addClass('fas fa-check hero_tick-icon');
    
                        $('.enrolment_section').css('display', 'none');
                        $('.js-enrolment_toggle').html(`View enrolment details <i aria-hidden="true" class="enrolment_toggle-icon fas fa-chevron-down"></i>`);
    
                    } else {
                        $('.js-hero_circle-enrolment-status').html('In progress');
    
                        $('.js-hero-enrolment-icon i').removeClass();
                        $('.js-hero-enrolment-icon i').addClass('fas fa-map-marker-alt');
                    }
                })


            }

            // isAuthorizedRepresentative without enrolment, dashboard page
            //! 1/12/2023 This will not work for enrolled auth reps who are also individuals  
            if($.sc.authSettings.isAuthorizedRepresentative === true && $.sc.authSettings.pplId !== null && $.sc.authSettings.hasPba === true){
                
                $('#maincontent').append(domSection.balanceHeroSection)
                $('#maincontent').append(domSection.balanceSection)

            }
                    
            // Display enrolment icons as completed or incompleted

            // My details
            if(data.IsMyDetailsCompleted === true){
                $('.js-my-details-icon').css('background-color', '#52DD8D');
                $('.js-my-details-icon i').removeClass();
                $('.js-my-details-icon i').addClass('fas fa-check enrolment_tick-icon');
                //$('.js-enrolment-details-text').html('View');

            } else {
                $('.js-my-details-icon').css('background-color', '#B11D73');
                $('.js-my-details-icon i').removeClass();
                $('.js-my-details-icon i').addClass('fas fa-address-card enrolment_details-icon');
                //$('.js-enrolment-details-text').html('Start');
            }
            $('.js-my-details-icon').css('background-color', '#52DD8D');
            $('.js-my-details-icon i').removeClass();
            $('.js-my-details-icon i').addClass('fas fa-check enrolment_tick-icon');
            //$('.js-enrolment-details-text').html('Change');

            // My signature
            if(data.IsMySignatureCompleted === true){
                $('.js-hero-signature-icon i').removeClass();
                $('.js-hero-signature-icon i').addClass('fas fa-check hero_tick-icon');
                $('.js-my-signature-icon').css('background-color', '#52DD8D');
                $('.js-my-signature-icon i').removeClass();
                $('.js-my-signature-icon i').addClass('fas fa-check enrolment_tick-icon');
                //$('.js-enrolment-signature-text').html('View');

            } else {
                $('.js-hero-signature-icon i').removeClass();
                $('.js-hero-signature-icon i').addClass('fas fa-map-marker-alt');
                $('.js-my-signature-icon').css('background-color', '#B11D73');
                $('.js-my-signature-icon i').removeClass();
                $('.js-my-signature-icon i').addClass('fas fa-pen-alt enrolment_pen-icon');
                //$('.js-enrolment-signature-text').html('Start');
            }

            // My Programs
            if(data.MyPrograms !== null) {
                if(data.MyPrograms.InProgressCount === 0 && data.MyPrograms.CompletedCount > 0){
                    $('.js-hero-programs-icon i').removeClass();
                    $('.js-hero-programs-icon i').addClass('fas fa-check hero_tick-icon');
                    $('.js-my-programs-icon').css('background-color', '#52DD8D');
                    $('.js-my-programs-icon').html('<p class="enrolment_completed-number js-enrolment_programs-number"></p>');
                    $('.js-enrolment_programs-number').html(data.MyPrograms.CompletedCount);
                    //$('.js-my-programs-text').html('Change');
    
                } else if(data.MyPrograms.InProgressCount === 0 && data.MyPrograms.CompletedCount === 0) {
                    $('.js-hero-programs-icon i').removeClass();
                    $('.js-hero-programs-icon i').addClass('fas fa-map-marker-alt');
                    $('.js-my-programs-icon').css('background-color', '#B11D73');
                    $('.js-my-programs-icon').html('<p class="enrolment_completed-number js-enrolment_programs-number">0</p>');
                    //$('.js-my-programs-text').html('Start');
    
                } else if(data.MyPrograms.InProgressCount > 0){
                    $('.js-hero-programs-icon i').removeClass();
                    $('.js-hero-programs-icon i').addClass('fas fa-map-marker-alt');
                    $('.js-my-programs-icon').css('background-color', '#B11D73');
                    $('.js-my-programs-icon').html('<p class="enrolment_completed-number js-enrolment_programs-number"></p>');
                    $('.js-enrolment_programs-number').html(data.MyPrograms.InProgressCount);
                   // $('.js-my-programs-text').html('Continue');
                }
            }

            // My designated representative
            if(data.IsMyAuthRepCompleted === true){
                $('.js-my-des-rep-icon').css('background-color', '#52DD8D');
                $('.js-my-des-rep-icon i').removeClass();
                $('.js-my-des-rep-icon i').addClass('fas fa-check enrolment_tick-icon');
                $('.js-my-des-rep-text').html('Change');

            } else {
                $('.js-my-des-rep-icon').css('background-color', '#B11D73');
                $('.js-my-des-rep-icon i').removeClass();
                $('.js-my-des-rep-icon i').addClass('fas fa-pen-alt enrolment_pen-icon');
                //$('.js-my-des-rep-text').html('Start');
            }

            // My Providers
            if(data.MyEmployees !== null) {
                if(data.MyEmployees.InProgressCount === 0 && data.MyEmployees.CompletedCount > 0){
                    $('.js-hero-providers-icon i').removeClass();
                    $('.js-hero-providers-icon i').addClass('fas fa-check hero_tick-icon');
                    $('.js-my-providers-icon').css('background-color', '#52DD8D');
                    $('.js-my-providers-icon').html('<p class="enrolment_completed-number js-enrolment_providers-number"></p>');
                    $('.js-enrolment_providers-number').html(data.MyEmployees.CompletedCount);
                    //$('.js-my-providers-text').html('Change');
    
                } else if(data.MyEmployees.InProgressCount === 0 && data.MyEmployees.CompletedCount === 0) {
                    $('.js-hero-providers-icon i').removeClass();
                    $('.js-hero-providers-icon i').addClass('fas fa-map-marker-alt');
                    $('.js-my-providers-icon').css('background-color', '#B11D73');
                    $('.js-my-providers-icon').html('<p class="enrolment_completed-number js-enrolment_providers-number">0</p>');
                    //$('.js-my-providers-text').html('Start');
    
                } else if(data.MyEmployees.InProgressCount > 0){
                    $('.js-hero-providers-icon i').removeClass();
                    $('.js-hero-providers-icon i').addClass('fas fa-map-marker-alt');
                    $('.js-my-providers-icon').css('background-color', '#B11D73');
                    $('.js-my-providers-icon').html('<p class="enrolment_completed-number js-enrolment_providers-number"></p>');
                    $('.js-enrolment_providers-number').html(data.MyEmployees.InProgressCount);
                   // $('.js-my-providers-text').html('Continue');
                }
            }
            
            // Toggle enrolment section arrow to face up/down
            $('.js-enrolment_toggle').on('click', function() {
                
                $('.enrolment_section').slideToggle();
                $('.enrolment_employee-section').slideToggle();
                if ($('.js-enrolment_toggle').html() === `View enrolment details <i aria-hidden="true" class="enrolment_toggle-icon fas fa-chevron-down"></i>`){
                    $('.js-enrolment_toggle').html(`Hide enrolment details <i aria-hidden="true" class="enrolment_toggle-icon fas fa-chevron-up"></i>`)
                } else {
                    $('.js-enrolment_toggle').html(`View enrolment details <i aria-hidden="true" class="enrolment_toggle-icon fas fa-chevron-down"></i>`)
                }
                
            })

            // Weekly funding dropdown toggle
            $('.js-weekly-funds-toggle').on('click keydown', function (e) {
                if (e.type === 'click' || e.key === 'Enter' || e.keyCode === 13) {
                    if($('.js-weekly-funds-toggle').hasClass('fa-chevron-circle-down')){
                        $('.js-weekly-funds-toggle').removeClass('fa-chevron-circle-down');
                        $('.js-weekly-funds-toggle').addClass('fa-chevron-circle-up');
                        $('.js-weekly-funds-toggle').attr('aria-expanded', 'true');
                    } else if($('.js-weekly-funds-toggle').hasClass('fa-chevron-circle-up')){
                        $('.js-weekly-funds-toggle').removeClass('fa-chevron-circle-up');
                        $('.js-weekly-funds-toggle').addClass('fa-chevron-circle-down');
                        $('.js-weekly-funds-toggle').attr('aria-expanded', 'false');
                    }

                    $('.js-weekly-funding-trans-container').slideToggle();
                    $('.funds_weekly-funding-container').toggleClass('funds_weekly-funding-container-border');
                }
            })

            // Weekly orders dropdown toggle
           $('.js-weekly-orders-toggle').on('click keydown', function (e) {

                // Trigger only on click or Enter key
                if (e.type === 'click' || e.key === 'Enter' || e.keyCode === 13) {

                    if ($(this).hasClass('fa-chevron-circle-down')) {
                        $(this).removeClass('fa-chevron-circle-down')
                            .addClass('fa-chevron-circle-up').attr('aria-expanded', 'true');
                    } else if ($(this).hasClass('fa-chevron-circle-up')) {
                        $(this).removeClass('fa-chevron-circle-up')
                            .addClass('fa-chevron-circle-down').attr('aria-expanded', 'false');;
                    }

                    $('.js-weekly-orders-trans-container').slideToggle();
                }
            });


            // Toggle the available balance info box
            $('body').on('click', '.js-available-balance-info-box-toggle', function(e){
                e.stopPropagation();
                $('.js-desktop-page-info-box').addClass('hide-info-box');
                $('.js-statement-available-balance-info-box').toggleClass('hide-info-box');
            });
            
            // Toggle the desktop page info box
            $('body').on('click', '.js-desktop-page-info-box-toggle', function(e){
                e.stopPropagation();
                $('.js-statement-available-balance-info-box').addClass('hide-info-box');
                $('.js-desktop-page-info-box').toggleClass('hide-info-box');
            });
            
            // Toggle the mobile page info box
            $('body').on('click', '.js-mobile-page-info-box-toggle', function(e){
                e.stopPropagation();
                $('.js-statement-available-balance-info-box').addClass('hide-info-box');
                $('.js-mobile-page-info-box').toggleClass('hide-info-box');
            });
        
            // Toggles off any info boxes when you click anywhere on the page
            $('body').on('click', function(){
                $('.js-mobile-page-info-box').addClass('hide-info-box');
                $('.js-desktop-page-info-box').addClass('hide-info-box');
                $('.js-statement-available-balance-info-box').addClass('hide-info-box');
            });

            $('.js-overlay').remove();
  
        //});
    
    };


    async function getProductTwo(callback){

        const statementTransactions = await getBalance($.sc.authSettings.id);
        console.log(statementTransactions.Data)
		const data = statementTransactions.Data;

        // Edit text in the hero circle to show the available balance if the wallet is active
        if(data){
            $('.js-hero_circle').html(
                `
                <h2 class="hero_circle-heading">Available balance</h2>
                <p class="hero_statement-circle-heading-bold js-available-balance"></p>
                <i aria-hidden="true" class="balance-info-icon fas fa-info-circle js-available-balance-info-box-toggle" aria-describedby="info-box-text-4" role="button" aria-label="More information" tabindex="0"></i>
                <div class="info-box js-statement-available-balance-info-box" role="tooltip" id="info-box-text-4">
                    <p class="info-box-text">Available balance is the amount you have available to spend and includes all paid and pending orders.</p>
                </div>
                `
            );

            // Get the current and avaiable balance
            $('.js-available-balance').html('£' + data.AvailableBalance.toFixed(2));
            $('.js-current-balance').html('£' + data.CurrentBalance.toFixed(2));

        } else {

            $('.js-hero_circle').html(
                `
                <h2 class="hero_circle-heading">Enrolment Status</h2>
                <p class="hero_circle-heading-bold js-hero_circle-enrolment-status">${currentState.displayEnrollmentSection === false ? `Enrolled` : `In progress`}</p>
                `
            )
        }

        
    
        if ( callback !== undefined) {
            callback();
        }
    }
    

    // Creates weekly funding table items
    function createWeeklyFundingTable() {
        
        $.getJSON(`/s4s/api/FundingDue/List?PrincipalId=${authSettings.id}`).done(function (response) {
    
            let weeklyTotal = 0;
    
            $(response.Data.Items).each(function(i, el){
    
                // If end date is in the future then show item and add up the totals
                if(new Date(el.EndDate) > new Date() || el.EndDate === null){
    
                    weeklyTotal = weeklyTotal + el.WeeklyAmount;
    
                    $('.js-weekly-funding-trans-container table').append(
                        `
                        <tr class="funds_weekly-trans-row">
                            <td class="funds_weekly-trans-name">${this.PaymentDescription}</td>
                            <td class="funds_weekly-trans-amount">£${this.WeeklyAmount.toFixed(2)}</td>
                        </tr>
                        `
                    );

                    $('.js-weekly-funding-trans-container table thead tr').append(
                        `<th scope="col" style="display:none">${this.PaymentDescription}</th>`
                    );
    
                    // Add weekly funding amount to the page
                    $('.js-total').text('£' + weeklyTotal.toFixed(2));
                };
            });
    
    
            
            // If there is not weekly total then display No weekly funding in the table
            if($('.js-weekly-funding-trans-container .funds_weekly-trans-row').length === 0) {
                $('.js-weekly-funding-trans-container table').append(
                    `
                    <tr class="funds_weekly-trans-row">
                        <td class="funds_weekly-trans-name">No weekly funding</td>
                    </tr>
                    `
                );

                $('.js-weekly-funding-trans-container table thead tr').append(
                        `<th scope="col" style="display:none">No weekly funding</th>`
                );
            };
    
            // If there is not weekly total then display £0.00
            if(weeklyTotal === 0 || weeklyTotal === '' || weeklyTotal === undefined || weeklyTotal === null){
    
                $('.js-total').text('£0.00');
            }
    
            $('.js-overlay').remove();
    
        
            // Creates onging weekly orders table items
            $.getJSON('/s4s/api/Balance/ExpectedSpends?PrincipalId=' + $.sc.authSettings.id ).done(function (data) {
    
                let totalAmount = 0;
                // Calculates weekly budget not is not currently being used
                for (var i = 0; i < data.Data.Items.length; i++) {
                    
                    let item = data.Data.Items[i];

                    const positiveAmount =  Math.abs(item.Amount);
    
                    //let weeklyCost = item.Amount;
                    totalAmount += positiveAmount;

                    // Ongoing weekly orders
                    const serviceProviderName = item.Type === 3 ? 'Manual Transaction Payment' : item.SupplierName;
    
                    if(serviceProviderName !== "" && serviceProviderName !== null && positiveAmount !== 0 && positiveAmount !== null){
    
                        $('.js-weekly-orders-trans-container table').append(
                            `
                            <tr class="funds_weekly-trans-row">
                                <td class="funds_weekly-trans-name">${serviceProviderName}</td>
                                <td class="funds_weekly-trans-amount">£${positiveAmount.toFixed(2)}</td>
                            </tr>
                            `
                        );

                        $('.js-weekly-orders-trans-containe table thead tr').append(
                            `<th scope="col" style="display:none">${serviceProviderName}</th>`
                        );
        
                    } 
    
                }


                // // var currentBalence = item.currentBalence;
                // Use FundingDue API as money in
                // Use ExpectedSpends as Money out

                // var weeklyOrders = item.weeklyOrdersTotal;
                var weeklyBudget = weeklyTotal - totalAmount;

                if ( weeklyBudget <= 0 ) {

                    $('.js-summary-info-box').append('<p class="warning"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Your weekly orders match or exceed your available funding</p>');

                    $('.js-summary-info-box').append('<p><i class="fa fa-coins" aria-hidden="true"></i> <strong>You have £0 remaining of your weekly budget that is not currently being spent on ongoing orders</strong></p>');
                    
                    $('.js-summary-info-box').removeClass('hide');

                } else {
                    
                    $('.js-summary-info-box').append('<p><i class="fa fa-coins" aria-hidden="true"></i> <strong>You have £' + weeklyBudget.toFixed(2) + ' remaining of your weekly budget that is not currently being spent on ongoing orders</strong></p>');
                    
                    $('.js-summary-info-box').removeClass('hide');

                }

                $('.js-weekly-cost').text('£' + totalAmount.toFixed(2));
    
                if($('.js-weekly-orders-trans-container .funds_weekly-trans-row').length === 0) {
                    
                    $('.js-weekly-orders-trans-container table').append(
                        `
                        <tr class="funds_weekly-trans-row">
                            <td class="funds_weekly-trans-name">No weekly orders</td>
                        </tr>
                        `
                    );

                    $('.js-weekly-orders-trans-container table thead tr').append(
                        `<th scope="col" style="display:none">No weekly orders</th>`
                    );
                }
    
                $('.js-overlay').remove();
    
            })
            .fail(function () {
    
                $('.js-overlay').remove();
    
            });
        });
    }


    async function getOrganisationsList() {
		const endpoint = new URL(`${window.location.protocol}//${window.location.host}/s4s/api/PPL/GetOrganisation/${authSettings.organisationId}`);
		const response = await fetch(endpoint);
		const data = await response.json();

        // If response is ok and the organisation API works
        if ( response.ok ) {
            return data;

        // Otherwise just run append the DOM elements
        } else {
            applyDOM('')
        }
	}

    async function getOrganisations() {

		const getSourceListEndpoint = await getOrganisationsList();
  
		if ( 
            getSourceListEndpoint &&
            getSourceListEndpoint.Data &&
            getSourceListEndpoint.Data !== null
         ) {
            if ( getSourceListEndpoint.Data.ProviderType === '2cde0c21-b2fe-422e-99e6-be8816ef2ee7') {
                applyDOM('Agency');
            } else {
                applyDOM('');
            }
        }
    }

    function applyDOM(providerType) {

        const perms = Array.isArray($.sc.authSettings.permissions) ? $.sc.authSettings.permissions : [];
        const fundingDue = Boolean($.sc.authSettings.isOriginalPrincipalSag) && perms.includes('ec2aa69b-db69-4a3e-a0c4-7a65401e64d5');
        const newTimesheetsPermissions = perms.includes('c9810ea9-1e5f-42c3-9547-2eb7e9dd027a');

        const params = currentState.summaryParameters.Data;

        // CORE-579 Logic to determine if enrollment section displays

        // Employer VW Lite
        if ( $.sc.authSettings.isEmployer === true && securityGuids.indexOf(Urls.virtualWalletLiteSecurityGroup) > -1 ) {
            if ( params.MyPrograms.CompletedCount > 0 && params.MyPrograms.InProgressCount === 0 ) {
                currentState.displayEnrollmentSection = false;
            }

        // Employer
        } else if ( $.sc.authSettings.isEmployer === true ) {
            if ( params.MyPrograms.CompletedCount > 0 && params.MyPrograms.InProgressCount === 0 && params.MyEmployees.CompletedCount > 0) {
                currentState.displayEnrollmentSection = false;
            }
        
        // Auth Rep
        } else if ( $.sc.authSettings.isAuthorizedRepresentative === true  ) {
            if ( params.MyPrograms.CompletedCount > 0 && params.MyPrograms.InProgressCount === 0 ) {
                currentState.displayEnrollmentSection = false;
            }
        
        // Provider
        } else if ($.sc.authSettings.isEmployee === true) {
            if ( params.MyPrograms.CompletedCount > 0 && params.MyPrograms.InProgressCount === 0) {
                currentState.displayEnrollmentSection = false;
            }
        }

        const enrollmentToggleMobileBtn = currentState.displayEnrollmentSection === true ? 
            `<button class="blue-btn enrolment_toggle-btn enrolment_toggle-btn-mobile js-enrolment_toggle">Hide enrolment details <i aria-hidden="true" class="enrolment_toggle-icon fas fa-chevron-up"></i></button>` 
            : 
            `<button class="blue-btn enrolment_toggle-btn enrolment_toggle-btn-mobile js-enrolment_toggle">View enrolment details <i aria-hidden="true" class="enrolment_toggle-icon fas fa-chevron-down"></i></button>`
        ;

        const enrollmentToggleDesktopBtn = currentState.displayEnrollmentSection === true ? 
            `<button class="blue-btn enrolment_toggle-btn enrolment_toggle-btn-desktop js-enrolment_toggle">Hide enrolment details <i aria-hidden="true" class="enrolment_toggle-icon fas fa-chevron-up"></i></button>` 
            : 
            `<button class="blue-btn enrolment_toggle-btn enrolment_toggle-btn-desktop js-enrolment_toggle">View enrolment details <i aria-hidden="true" class="enrolment_toggle-icon fas fa-chevron-down"></i></button>`
        ;

        


        // Create Contract tile
        console.log('currentState.IsTimesheetEnabled is: ' + currentState.IsTimesheetEnabled);

        let contractTile = '';
        if ( currentState.IsTimesheetEnabled === true ) {
            contractTile = `
            <li class="enrolment_item-container">
                <a class="enrolment_item-anchor" href="/s4s/ContractDetails">
                    <div class="enrolment_item-icon-container">
                        <div class="enrolment_item-outer-icon-shape js-my-signature-icon" style="background-color: rgb(177, 29, 115);">
                            <i aria-hidden="true" class="fas fa-pen-alt enrolment_pen-icon"></i>
                        </div>
                    </div>
                    <div class="enrolment_item-text-container">
                        <p class="enrolment_item-detail">Contract</p>
                    </div>
                    <div class="enrolment_item-detail-icon-container">
                        <i aria-hidden="true" class="header-nav_item-icon-right-mobile fas fa-chevron-right"></i>
                    </div>
                </a>
            </li>`
        }


        domSection = {
            // Hero sections
            'blankHeroSection' : `
                <div class="hero hero_section">
                    <div class="pcg-page-wrapper container site-container">
                        <div class="hero_blank-section-container">
                            <h1 class="hero_blank-section-main-heading heading-1">My Virtual Wallet Dashboard</h1>
                        </div>
                    </div>
                </div>
            `,

            'balanceHeroSection' : `
                <!-- Hero section -->
                <div class="hero hero_section">
                    <div class="pcg-page-wrapper container site-container">
                        <div class="hero_container hero_dashboard-container">
                            <div class="hero-placeholder"></div>
                             <div class="hero_lower-text-container">
                                <h1 class="hero_main-heading hero_main-heading-tablet-desktop">
                                My Virtual Wallet Dashboard

                                    <span class="tooltip-wrapper">
                                    <i aria-hidden="true"
                                        class="balance-info-icon fas fa-info-circle js-desktop-page-info-box-toggle"
                                        aria-describedby="info-box-text-3"
                                        role="button"
                                        aria-label="More information"
                                        tabindex="0"></i>

                                    <div class="desktop-page-info-box js-desktop-page-info-box hide-info-box"
                                        role="tooltip"
                                        id="info-box-text-3">
                                        <p class="info-box-text">
                                            Your dashboard shows a weekly summary of the funding you should receive in your Virtual Wallet and any regular ongoing orders you have each week
                                        </p>
                                    </div>
                                    </span>
                                </h1>
                            </div>
                            
                            <div class="hero_dashoboard-circle-container">
                                <div class="hero_circle js-hero_circle">
                                    <h2 class="hero_circle-heading">Available balance</h2>
                                    <p class="hero_statement-circle-heading-bold js-available-balance"></p>
                                    <i aria-hidden="true" class="balance-info-icon fas fa-info-circle js-available-balance-info-box-toggle" aria-describedby="info-box-text-2" role="button" aria-label="More information" tabindex="0"></i>
                                    <div class="info-box js-statement-available-balance-info-box" role="tooltip" id="info-box-text-2">
                                        <p class="info-box-text">Available balance is the amount you have available to spend and includes all paid and pending orders.</p>
                                    </div>
                                </div>
                            </div>
                           
                        </div>
                    </div>
                </div>
            `,

            'individualEnrolmentHeroSection' :  `
                <!-- Hero section -->
                <div class="hero hero_section">
                    <div class="pcg-page-wrapper container site-container">
                        <div class="hero_container hero_dashboard-container">
                            <div class="hero-placeholder"></div>

                             <div class="hero_lower-text-container">
                                <h1 class="hero_main-heading hero_main-heading-tablet-desktop">My Virtual Wallet Dashboard</h1>
                                <p class="hero_lower-text_description">Now that you have registered for Virtual Wallet, please do the following items to complete your enrolment.</p>
                                ${currentState.IsElectronic === true ? 
                                    ``  : 
                                    `
                                    <div class="hero_enrol-item-container js-hero-signature-icon">
                                        <i aria-hidden="true"></i>
                                        <p>Add your electronic signature</p>
                                    </div>
                                    `
                                }
                                
                                <div class="hero_enrol-item-container js-hero-enrolment-icon">
                                    <i aria-hidden="true"></i>
                                    <p>Complete your program enrolment</p>
                                </div>
                                <div class="hero_enrol-item-container js-hero-providers-icon">
                                    <i aria-hidden="true"></i>
                                    <p>Review your providers</p>
                                </div>
                                ${enrollmentToggleDesktopBtn}
                                ${enrollmentToggleMobileBtn}
                            </div>
                            <div class="hero_dashoboard-circle-container">
                                <div class="hero_circle js-hero_circle">
                                    <h2 class="hero_circle-heading"></h2>
                                    <p class="hero_circle-heading-bold js-hero_circle-enrolment-status"></p>
                                </div>
                            </div>
                           
                        </div>
                    </div>
                </div>
            `,

            'employeeEnrolmentHeroSection' : `
                <!-- Hero section -->
                <div class="hero hero_section">
                    <div class="pcg-page-wrapper container site-container employeeEnrolmentHeroSection">
                        <div class="hero_container hero_dashboard-container">
                            <div class="hero-placeholder"></div>

                            
                            <div class="hero_lower-text-container">
                                <h1 class="hero_main-heading hero_main-heading-tablet-desktop">My Virtual Wallet Dashboard</h1>
                                <p class="hero_lower-text_description">Now that you have registered for Virtual Wallet, please do the following to complete your enrolment and begin to work as an individual you support:</p>
                                ${currentState.IsElectronic === true ? 
                                    ``  : 
                                    `
                                    <div class="hero_enrol-item-container js-hero-signature-icon">
                                        <i aria-hidden="true"></i>
                                        <p>Add your electronic signature</p>
                                    </div>
                                    `
                                }
                                ${$.sc.authSettings.isAuthorizedRepresentative === true ?
                                `` 
                                : 
                                `<div class="hero_enrol-item-container js-hero-enrolment-icon">
                                    <i aria-hidden="true"></i>
                                    <p>Complete your program enrolment</p>
                                </div>`
                                }
                                <div class="hero_enrol-item-container js-hero-programs-icon">
                                    <i aria-hidden="true" class="fas fa-map-marker-alt"></i>
                                    <p>${$.sc.authSettings.isAuthorizedRepresentative === true ? `Complete and sign your agreement` : `Review your programs`}</p>
                                </div>
                                ${enrollmentToggleDesktopBtn}
                                ${enrollmentToggleMobileBtn}
                            </div>
                            <div class="hero_dashoboard-circle-container">
                                <div class="hero_circle js-hero_circle">
                                    <h2 class="hero_circle-heading"></h2>
                                    <p class="hero_circle-heading-bold js-hero_circle-enrolment-status"></p>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            `,

            'individualEnrolmentSection' : `
                <div class="enrolment enrolment_section" ${currentState.displayEnrollmentSection === false ? ` style="display: none"` : ``}>
                    <div class="pcg-page-wrapper container site-container">
                        <div class="enrolment_container">
                            <h2 class="enrolment_section-heading">Please do the following to complete your enrolment.</h2>
                            <nav aria-label = "Primary Enrolment">
                                <ul class="enrolment_items-container enrolment_primary-items-container">
                                    <li class="enrolment_item-container">
                                        <a class="enrolment_item-anchor" href="${(Urls.urlpath + Urls.myDetails)}">
                                            <div class="enrolment_item-icon-container">
                                                <div class="enrolment_item-outer-icon-shape js-my-details-icon">
                                                    <i aria-hidden="true"></i>
                                                </div>
                                            </div>
                                            <div class="enrolment_item-text-container">
                                                <p class="enrolment_item-detail">My details</p>
                                            </div>
                                            <div class="enrolment_item-detail-icon-container">
                                                <i aria-hidden="true" class="header-nav_item-icon-right-mobile fas fa-chevron-right"></i>
                                            </div>
                                        </a>
                                    </li>
                                    <li class="enrolment_item-container ${currentState.IsElectronic === true ? 'readonly' : ''}">
                                        ${currentState.IsElectronic === true ? 
                                        `<div class="enrolment_item-anchor">`
                                            : 
                                        `<a class="enrolment_item-anchor" href="${(Urls.urlpath + Urls.mySignatures)}">`
                                        }
                                            <div class="enrolment_item-icon-container">
                                                <div class="enrolment_item-outer-icon-shape js-my-signature-icon">
                                                    <i aria-hidden="true"></i>
                                                </div>
                                            </div>
                                            <div class="enrolment_item-text-container">
                                                <p class="enrolment_item-detail">Signature</p>
                                            </div>
                                            <div class="enrolment_item-detail-icon-container">
                                                <i aria-hidden="true" class="header-nav_item-icon-right-mobile fas fa-chevron-right"></i>
                                            </div>
                                        ${currentState.IsElectronic === true ? 
                                        `</div>`
                                            : 
                                        `</a>`
                                        }
                                    </li>
                                    <li class="enrolment_item-container ${currentState.IsElectronic === true ? 'readonly' : ''}">
                                        ${currentState.IsElectronic === true ? 
                                        `<div class="enrolment_item-anchor">`
                                            : 

                                        `<a class="enrolment_item-anchor" href="${providerType === 'Agency' ? `/s4s/CustomPage/Index/${Urls.agencyEnrolments}` : (Urls.urlpath + Urls.myPrograms) }">`
                                        
                                        }
                                            <div class="enrolment_item-icon-container">
                                                <div class="enrolment_item-outer-icon-shape js-my-programs-icon">
                                                </div>
                                            </div>
                                            <div class="enrolment_item-text-container">
                                                <p class="enrolment_item-detail">Agreements</p>
                                            </div>
                                            <div class="enrolment_item-detail-icon-container">
                                                <i aria-hidden="true" class="header-nav_item-icon-right-mobile fas fa-chevron-right"></i>
                                            </div>
                                        ${currentState.IsElectronic === true ? 
                                        `</div>`
                                            : 
                                        `</a>`
                                        }
                                    </li>
                                </ul>
                            </nav>
                            

                            ${currentState.IsTimesheetEnabled === true ? 
                                `<nav aria-label = "Primary Enrolment"><ul class="enrolment_items-container enrolment_primary-items-container">` : 
                                `<nav aria-label = "Additional Enrolment"><ul class="enrolment_items-container enrolment_secondary-items-container">`
                            }
                                <li class="enrolment_item-container">
                                    <a class="enrolment_item-anchor" href="${(Urls.urlpath + Urls.myDesignatedRep)}">
                                        <div class="enrolment_item-icon-container">
                                            <div class="enrolment_item-outer-icon-shape js-my-des-rep-icon">
                                                <i aria-hidden="true"></i>
                                            </div>
                                        </div>
                                        <div class="enrolment_item-text-container">
                                            <p class="enrolment_item-detail">Representatives</p>
                                        </div>
                                        <div class="enrolment_item-detail-icon-container">
                                            <i aria-hidden="true" class="header-nav_item-icon-right-mobile fas fa-chevron-right"></i>
                                        </div>
                                    </a>
                                </li>
                                <li class="enrolment_item-container">
                                    <a class="enrolment_item-anchor" href="${(Urls.urlpath + Urls.myProviders)}">
                                        <div class="enrolment_item-icon-container">
                                            <div class="enrolment_item-outer-icon-shape js-my-providers-icon">
                                            </div>
                                        </div>
                                        <div class="enrolment_item-text-container">
                                            <p class="enrolment_item-detail">Providers</p>
                                        </div>
                                        <div class="enrolment_item-detail-icon-container">
                                            <i aria-hidden="true" class="header-nav_item-icon-right-mobile fas fa-chevron-right"></i>
                                        </div>
                                    </a>
                                </li>
                                ${currentState.IsTimesheetEnabled === true ? 
                                    contractTile: 
                                    ``
                                }
                            </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            `,

            'employeeEnrolmentSection' : `
                <!-- Enrolment section -->
                <div class="enrolment enrolment_employee-section" ${currentState.displayEnrollmentSection === false ? ` style="display: none"` : ``}>
                    <div class="pcg-page-wrapper container site-container">
                        <div class="enrolment_container">
                            <h2 class="enrolment_section-heading">Please do the following to complete your enrolment.</h2>
                            <nav aria-label = "Primary Enrolment">
                                <ul class="enrolment_items-container enrolment_primary-items-container">
                                    <li class="enrolment_item-container">
                                        <a class="enrolment_item-anchor" href="${(Urls.urlpath + Urls.myDetails)}">
                                            <div class="enrolment_item-icon-container">
                                                <div class="enrolment_item-outer-icon-shape js-my-details-icon">
                                                    <i aria-hidden="true"></i>
                                                </div>
                                            </div>
                                            <div class="enrolment_item-text-container">
                                                <p class="enrolment_item-detail">My details</p>
                                            </div>
                                            <div class="enrolment_item-detail-icon-container">
                                                <i aria-hidden="true" class="header-nav_item-icon-right-mobile fas fa-chevron-right"></i>
                                            </div>
                                        </a>
                                    </li>
                                    <li class="enrolment_item-container">
                                        <a class="enrolment_item-anchor" href="${(Urls.urlpath + Urls.mySignatures)}">
                                            <div class="enrolment_item-icon-container">
                                                <div class="enrolment_item-outer-icon-shape js-my-signature-icon">
                                                    <i aria-hidden="true"></i>
                                                </div>
                                            </div>
                                            <div class="enrolment_item-text-container">
                                                <p class="enrolment_item-detail">Signature</p>
                                            </div>
                                            <div class="enrolment_item-detail-icon-container">
                                                <i aria-hidden="true" class="header-nav_item-icon-right-mobile fas fa-chevron-right"></i>
                                            </div>
                                        </a>
                                    </li>
                                    <li class="enrolment_item-container">
                                        <a class="enrolment_item-anchor" href="${providerType === 'Agency' ? `/s4s/CustomPage/Index/${Urls.agencyEnrolments}` : (Urls.urlpath + Urls.myPrograms) }">
                                            <div class="enrolment_item-icon-container">
                                                <div class="enrolment_item-outer-icon-shape js-my-programs-icon">
                                                </div>
                                            </div>
                                            <div class="enrolment_item-text-container">
                                                <p class="enrolment_item-detail">Agreements</p>
                                            </div>
                                            <div class="enrolment_item-detail-icon-container">
                                                <i aria-hidden="true" class="header-nav_item-icon-right-mobile fas fa-chevron-right"></i>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                            
                            ${currentState.IsTimesheetEnabled === true ? 
                                `<ul class="enrolment_items-container ">${contractTile}</ul>`: 
                                ``
                            }
                        </div>
                    </div>
                </div>
            `,

            'authRepEnrolmentSection' : `
                <!-- Enrolment section -->
                <div class="enrolment enrolment_employee-section" ${currentState.displayEnrollmentSection === false ? ` style="display: none"` : ``}>
                    <div class="pcg-page-wrapper container site-container">
                        <div class="enrolment_container">
                            <h2 class="enrolment_section-heading">Please do the following to complete your enrolment.</h2>
                            <nav aria-label = "Primary Enrolment">
                                <ul class="enrolment_items-container enrolment_primary-items-container">
                                    <li class="enrolment_item-container">
                                        <a class="enrolment_item-anchor" href="/s4s/MyProfile/MyProfileTab">
                                            <div class="enrolment_item-icon-container">
                                                <div class="enrolment_item-outer-icon-shape js-my-details-icon">
                                                    <i aria-hidden="true"></i>
                                                </div>
                                            </div>
                                            <div class="enrolment_item-text-container">
                                                <p class="enrolment_item-detail">My details</p>
                                            </div>
                                            <div class="enrolment_item-detail-icon-container">
                                                <i aria-hidden="true" class="header-nav_item-icon-right-mobile fas fa-chevron-right"></i>
                                            </div>
                                        </a>
                                    </li>
                                    <li class="enrolment_item-container">
                                        <a class="enrolment_item-anchor" href="${(Urls.urlpath + Urls.mySignatures)}">
                                            <div class="enrolment_item-icon-container">
                                                <div class="enrolment_item-outer-icon-shape js-my-signature-icon">
                                                    <i aria-hidden="true"></i>
                                                </div>
                                            </div>
                                            <div class="enrolment_item-text-container">
                                                <p class="enrolment_item-detail">Signature</p>
                                            </div>
                                            <div class="enrolment_item-detail-icon-container">
                                                <i aria-hidden="true" class="header-nav_item-icon-right-mobile fas fa-chevron-right"></i>
                                            </div>
                                        </a>
                                    </li>
                                    <li class="enrolment_item-container">
                                        <a class="enrolment_item-anchor" href="${providerType === 'Agency' ? `/s4s/CustomPage/Index/${Urls.agencyEnrolments}` : (Urls.urlpath + Urls.myPrograms) }">
                                            <div class="enrolment_item-icon-container">
                                                <div class="enrolment_item-outer-icon-shape js-my-programs-icon">
                                                </div>
                                            </div>
                                            <div class="enrolment_item-text-container">
                                                <p class="enrolment_item-detail">Agreements</p>
                                            </div>
                                            <div class="enrolment_item-detail-icon-container">
                                                <i aria-hidden="true" class="header-nav_item-icon-right-mobile fas fa-chevron-right"></i>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                            
                        </div>
                    </div>
                </div>
                <div class="quick-link_section">
                    <div class="pcg-page-wrapper container site-container">
                        <div class="quick-link_container">
                            <div class="quick-link_item-container">
                                <div class="quick-link_icon-container">
                                    <i aria-hidden="true" class="quick-link_icon fas fa-user"></i>
                                </div>
                                <a href="${(Urls.urlpath + Urls.myParticipants)}" class="quick-link_btn">Individuals</a>
                            </div>
                        </div>
                    </div>
                </div>
            `,

            'balanceSection' :  `
                <!-- Balance section -->
                <div class="funds funds_section">
                    <div class="pcg-page-wrapper container site-container">
                        <section class="funds_balance-calculator-section" aria-label="Current balance tree">
                            <ul class="funds_container ${$.sc.authSettings.securityGroups.indexOf(Urls.virtualWalletLiteSecurityGroup) > -1 ? `` : `moneyInOut`}">
                                <li class="funds_balance-container funds_current-balance-container">
                                    <h2 class="funds_heading funds_current-balance-heading">Current balance</h2>
                                    <p class="funds_money-balance js-current-balance"></p>
                                    <p class="funds_current-balance-info">Your current balance does not include any pending transactions so may be different to the amount you are able to spend</p>
                                </li>
                                ${ 
                                    $.sc.authSettings.securityGroups.indexOf(Urls.virtualWalletLiteSecurityGroup) > -1 ? ``
                                    :
                                    `
                                        <li class="funds_balance-container funds_weekly-funding-container funds_weekly-funding-container-border">
                                            <div class="funds_currency-image-container">
                                                <i aria-hidden="true" class="funds_money-in-icon fas fa-arrow-alt-circle-down" alt=""></i>
                                            </div>
    
                                            <div class="funds_weekly-balance-details-container">
                                                <p class="funds_money-in-out-text" id="weekly-funding-title">Money In</p>
                                                <h3 class="funds_heading funds_weekly-funding-heading">Weekly funding</h3>
                                                <div class="funds_balance-toggle-container">
                                                    <p class="funds_money-balance funds_weekly-fund-balance js-total"></p>
                                                    <i aria-hidden="true" role="button" class="funds_balance-toggle-icon fas fa-chevron-circle-down js-weekly-funds-toggle" tabindex="0" aria-expanded="false" aria-labelledby="weekly-funding-title" aria-controls="weekly-funding"></i>
                                                </div>
                                                <div class="funds_weekly-container funds_weekly-funding-trans-container js-weekly-funding-trans-container" id="weekly-funding">
                                                    <table class="funds_weekly-container-table">
                                                        <caption style="display:none">Weekly Funding</caption>
                                                         <thead>
                                                            <tr>
                                                            </tr>
                                                        </thead>
                                                    </table>
                                                </div>
                                            </div>
                                            
                                            ${ fundingDue === true ? `<a class="blue-btn" href="${(Urls.urlpath + Urls.fundingDue)}" style="margin-top: 1rem;font-size: 0.9rem;">Due funding</a>` : `` }
                                        </li>
                                        <li class="funds_balance-container funds_ongoing-orders-container">
                                            <div class="funds_currency-image-container">
                                                <i aria-hidden="true" class="funds_money-out-icon fas fa-arrow-alt-circle-up" alt=""></i>
                                            </div>
                                            <div class="funds_weekly-balance-details-container">
                                                <p class="funds_money-in-out-text" id="ongoing-weekly-costs-title">Money Out</p>
                                                <h3 class="funds_heading funds_weekly-funding-heading">Average ongoing weekly costs 
                                                     <span class="tooltip-wrapper">
                                                        <i aria-hidden="true"
                                                            class="fas fa-info-circle"
                                                            aria-describedby="info-box-text-5"
                                                            role="button"
                                                            aria-label="More information"
                                                            tabindex="0"></i>

                                                        <div class="info-box-text-purple"
                                                            role="tooltip"
                                                            id="info-box-text-5">
                                                            <p class="">
                                                                The average value is calculated as the sum over the last 4 weeks divided by 4. For new users, the calculation includes the costs for the number of full weeks from today until the registration date.
                                                            </p>
                                                        </div>
                                                    </span>
                                                </h3>
                                                <div class="funds_balance-toggle-container">
                                                    <p class="funds_money-balance funds_weekly-orders-balance js-weekly-cost"></p>
                                                    <i aria-hidden="true" role="button" class="funds_balance-toggle-icon fas fa-chevron-circle-down js-weekly-orders-toggle" tabindex="0" aria-labelledby="ongoing-weekly-costs-title" aria-controls="ongoing-weekly-costs"></i>
                                                </div>
                                                <div class="funds_weekly-container funds_weekly-orders-trans-container js-weekly-orders-trans-container" id="ongoing-weekly-costs">
                                                    <table class="funds_weekly-container-table">
                                                        <caption style="display:none">Average ongoing weekly costs</caption>
                                                         <thead>
                                                            <tr>
                                                            </tr>
                                                        </thead>
                                                    </table>
                                                </div>
                                            </div>
                                            
                                        </li>
                                    `
                                }
                            </ul>
                            <div class="funds_calculator-section js-summary-info-box hide"></div>
                        </section>
                    </div>
                </div>
            `,

            'quickLinksSection' : `
                <!-- Quick links section -->
                <div class="quick-link_section">
                    <div class="pcg-page-wrapper container site-container">
                        <div class="quick-link_container">

                            <div class="quick-link_item-container">
                                <div class="quick-link_icon-container">
                                    <i aria-hidden="true" class="quick-link_icon fas fa-box"></i>
                                </div>
                                <a href="/s4s/Orders" class="quick-link_btn">Orders</a>
                            </div>

                            <div class="quick-link_item-container">
                                <div class="quick-link_icon-container">
                                    <i aria-hidden="true" class="quick-link_icon fas fa-file-invoice"></i>
                                </div>
                                <a href="/s4s/InvoiceDocuments" class="quick-link_btn">Invoices</a>
                            </div>

                            ${newTimesheetsPermissions === true ?
                                `
                                    <div class="quick-link_item-container">
                                        <div class="quick-link_icon-container">
                                            <i aria-hidden="true" class="quick-link_icon fas fa-clock"></i>
                                        </div>
                                        <a href="/s4s/ProviderTimesheetAdministration/Summary/timesheets/summary" class="quick-link_btn">Timesheets</a>
                                    </div>
                                    
                                    <div class="quick-link_item-container">
                                        <div class="quick-link_icon-container">
                                             <i aria-hidden="true" class="quick-link_icon fas fa-plus-circle"></i>
                                        </div>
                                        <a href="/s4s/ProviderActivities/activities/summary" class="quick-link_btn">Add activity</a>
                                    </div>
                                `
                                :
                                `
                                    <div class="quick-link_item-container">
                                        <div class="quick-link_icon-container">
                                            <i aria-hidden="true" class="quick-link_icon fas fa-clock"></i>
                                        </div>
                                        <a href="${(Urls.urlpath + Urls.providerTimesheetsAdmin)}" class="quick-link_btn">Timesheets</a>
                                    </div>
                                    
                                    <div class="quick-link_item-container">
                                        <div class="quick-link_icon-container">
                                            <i aria-hidden="true" class="quick-link_icon fas fa-file-alt"></i>
                                        </div>
                                        <a href="/s4s/ProviderTimesheetAdministration/Create" class="quick-link_btn">New timesheets</a>
                                    </div>
                                `
                             }
                            
                        </div>
                    </div>
                </div>
            ` 
        }

        $('#maincontent').append(vwDashboardPage());
 

        // } else {

        //     // Hide header and footer
        //     $('header').hide();
        //     $('footer').hide();

        //     // Show spinner before page redirects to designated target
        //     $('body').prepend(
        //         '<div class="js-overlay" style="width: 100%; height: 100%; position: fixed; z-index: 10000000; top: 0; display: flex; justify-content: center; background-color: rgba(0, 0, 0, 0.2)">' +
        //         '<svg style="width: 80px;" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="spinner" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-spinner fa-w-16 fa-spin fa-lg"><path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z" class=""></path></svg>' +
        //         '</div>'
        //     );

            //window.location.href = "/s4s/CustomPage/Index/" + Urls.vwLitePageId; 
        //}
    }


	var Attributes = {
		init: function() {
			this.adjustDom();
			this.bindUIActions();

            // Push securityGroups guids into array
            $(authSettings.securityGroups).each(function(i, el){
                securityGuids.push(el);
            });

            // Check to see if organisation exists for agency users

            summaryParameters(function(response){

                currentState.summaryParameters = response;

                if ($.sc.authSettings.isEmployer === true ) {
                    getPPLUser($.sc.authSettings.id, function(){
                        getHiringPrograms(getOrganisations);
                    });
                } else {
                    getOrganisations();
                }

            });

		},

		adjustDom: function() {
            overlay();
		},

		bindUIActions: function() {
 
		}
	};

	Attributes.init();

})();